import HeaderSection from "@/components/header/hello"; // Importa el componente
import ShippingEditComponent from "@/components/server/ShippingEdit";

const ShippingEdit = () => {
    return (
        <div className="space-y-4">
            <HeaderSection
                title="Editar envío / punto de retiro"
                description="Puedes cambiar a donde quieres que enviemos tus cajas"
            />
            <ShippingEditComponent />
        </div>
    );
};

export default ShippingEdit;
